<template>
    <router-link
        v-if="node.href"
        class="name"
        :to="node.href"
        @mouseenter="show($event, node)"
    >
        <span>{{ node.caption }}</span>
    </router-link>
    <a
        v-else
        class="name"
        @mouseenter="show($event, node)"
        @click.prevent="click"
    >
        <span>{{ node.caption }}</span>
    </a>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            node: {
                type: Object,
                require: true,
            },
        },
        methods: {
            ...mapMutations([
                'pushToolTip',
            ]),
            click: function(){ 
                this.$emit('click')
            },
            show: function(evt, opt){
                
                this.pushToolTip({
                    type: 'toolTip',
                    event: evt,
                    content: {
                        caption: null,
                        html: opt.caption
                    },
                    pointerEvents: 'none'
                })
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
